module.exports = __webpack_public_path__ + "static/media/WeeklySpecials.a62f31c3.pdf";